<template>
    <div>
        <div class="mx-auto w-20 h-20 rounded-full border-4 border-blue-450 overflow-hidden -mb-10 relative z-10">
            <img
                :src="avatar"
                class="block w-full h-full bg-blue-450"
            />
        </div>

        <div class="bg-blue p-6 pt-12">
            <form novalidate>
                <!-- Blank field start-->
                <div class="d-none" id="blank-id-wrapper">
                    <label>Keep this field blank</label>
                    <input type="text" name="blank-id" id="blank-id" value=""/>
                </div>
                <!-- Blank field end -->

                <!-- Username -->
                <div class="form-group mb-4">
                    <label class="sr-only" for="email">Email</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-envelope mx-auto" style="color: #ffffff !important;"></i>
                            </div>
                        </div>
                        <input
                            required
                            autofocus
                            id="email"
                            name="email"
                            type="email"
                            v-model="email"
                            dusk="login-email"
                            placeholder="Email"
                            @blur="updateAvatar"
                            @input="$v.email.$touch"
                            class="form-control p-3 bg-blue-450 border-blue text-white"
                        />
                    </div>
                </div>

                <vue-recaptcha class="input-group mb-4" ref="recaptcha" @verify="recaptchaVerify" :sitekey="recaptchasitekey"></vue-recaptcha>

                <button
                    type="button"
                    @click.prevent="startPasswordReset()"
                    class="btn btn-block btn-lg"
                    :class="{
                        'btn-success': canSubmit,
                        'btn-light cursor-not-allowed': cannotSubmit,
                    }"
                >
                    Send Password Reset Link  <i v-if="submitting" class="far fa-spinner-third fa-spin"></i>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { email, required } from 'vuelidate/lib/validators';

export default {
    components: {
        VueRecaptcha,
    },

    props: {
        recaptchasitekey: String,
    },

    data: function () {
        return {
            email: '',
            submitting: false,
            recaptchaResponse: '',
            avatar: '/img/avatar.svg',
        };
    },

    validations: {
        email: {
            email,
            required,
        },
    },

    computed: {
        canSubmit: function () {
            return ! this.$v.$invalid
                && !! this.recaptchaResponse;
        },

        cannotSubmit: function () {
            return this.canSubmit === false;
        },
    },

    methods: {
        updateAvatar() {
            if(!this.$v.email.$invalid){
                this.getGravatar({email: this.email})
                    .then((response) => {
                        this.avatar = response.data.avatarUrl;
                    })
                    .catch((error) => {
                        this.avatar = '/img/avatar.svg';
                    });
            } else {
                this.avatar = '/img/avatar.svg';
            }
        },

        recaptchaVerify: function (response) {
            this.recaptchaResponse = response;
        },

        resetRecaptcha: function () {
            this.$refs.recaptcha.reset();
        },

        startPasswordReset: function () {
            if (this.submitting || this.cannotSubmit) {
                return;
            }

            this.submitting = true;

            let blank = document.querySelector('#blank-id');

            this.resetPassword({
                email: this.email,
                'blank-id': blank.value,
                recaptcha: this.recaptchaResponse,
            }).then(response => {
                if (response.data.status === 'success') {
                    this.$swal({
                        type:'success',
                        title: 'Check your email for further instructions',
                        showConfirmButton: false,
                        timer: 3000
                    });

                    this.email = '';
                } else {
                    this.$swal({
                        type:'error',
                        title: 'Failed to reset password',
                        html: response.data.message,
                        showConfirmButton: true,
                        confirmButtonClass: 'btn btn-danger',
                        buttonsStyling: false,
                    });
                }

                // Reset vuelidate
                this.$nextTick(() => this.$v.$reset());
                this.resetRecaptcha();
                this.submitting = false;
            }).catch(error => {
                this.$swal({
                    type:'error',
                    title: 'Unable to reset password',
                    html: 'Please try again later',
                    showConfirmButton: true,
                    confirmButtonClass: 'btn btn-danger',
                    buttonsStyling: false,
                });

                this.submitting = false;
                this.resetRecaptcha();
            });
        },
    },
}
</script>
